export enum GeneralStatus {
  Active = 1,
  Inactive = 0
}
export const GeneralStatusLabel = new Map<number, string>([
  [GeneralStatus.Active, 'Ativo'],
  [GeneralStatus.Inactive, 'Inativo']
]);